<div class="container" id="spinerLoader" *ngIf="loader">
    <div class="loader">Loading...</div>
</div>
<div class="modal fade" data-backdrop="static" data-keyboard="false" id="addEditVehicle" role="dialog">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header content-header">
                <button type="button" class="close close-btn" data-dismiss="modal"
                    (click)="clearVehicleData();resetForm(loginForm);emitPopupCloseEvent()" aria-label="Close"><i
                        class="fa fa-close fa-md"></i></button>
                <h4 class="modal-title">{{headerName}} {{serviceType=='Air'?'Aircraft':'Vehicle'}}</h4>
            </div>
            <form name="loginForm" #loginForm="ngForm">
                <div class="modal-body">
                    <div class="member-card">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ vehicleTitle }} <span class="text-danger"><b>*</b></span></label>
                                    <input type="text"
                                           id="vehiclename"
                                           [placeholder]="vehicleTitle"
                                           name="vehicle_name"
                                           #vehicle_name="ngModel"
                                           class="form-control"
                                           [(ngModel)]="vehicle.vehicleName"
                                           maxlength="45"
                                           [ngClass]="{ 'is-invalid': loginForm.submitted && vehicle_name.invalid }"
                                           required
                                    >
                                    <div *ngIf="loginForm.submitted && vehicle_name.invalid" class="invalid-feedback">
                                        <div *ngIf="vehicle_name.errors.required"><span style="color: red;">
                                                {{serviceType=='Ground'?'Vehicle':'Aircraft'}} name required.</span>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">

                                    <label>Make<span class="text-danger"><b>*</b></span></label>
                                    <input type="text" id="vehiclemake" placeholder="Make" name="vehicle_Make"
                                        #vehicle_Make="ngModel" class="form-control" [(ngModel)]="vehicle.companyName"
                                        maxlength="45"
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && vehicle_Make.invalid }"
                                        required>
                                    <div *ngIf="loginForm.submitted && vehicle_Make.invalid" class="invalid-feedback">
                                        <div *ngIf="vehicle_Make.errors.required"><span style="color: red;"> Make is
                                                required.</span></div>
                                    </div>

                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">

                                    <label>Model<span class="text-danger"><b>*</b></span></label>
                                    <input type="text" id="modelname" placeholder="Model" name="model_name"
                                        maxlength="45" #model_name="ngModel" class="form-control"
                                        [(ngModel)]="vehicle.model"
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && model_name.invalid }"
                                        required>
                                    <div *ngIf="loginForm.submitted && model_name.invalid" class="invalid-feedback">
                                        <div *ngIf="model_name.errors.required">
                                            <span style="color: red;">
                                                Model is required.
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ vehicleNumberTitle }} <span class="text-danger"><b>*</b></span></label>
                                    <input type="text" id="vehicle_no"
                                        [placeholder]="serviceType=='Ground'?'Plate Number':'Tail#'" name="vehicle_no"
                                        maxlength="45" #vehicle_no="ngModel" class="form-control"
                                        [(ngModel)]="vehicle.vehicleNumber"
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && vehicle_no.invalid }"
                                        required>
                                    <div *ngIf="loginForm.submitted && vehicle_no.invalid" class="invalid-feedback">
                                        <div *ngIf="vehicle_no.errors.required">
                                            <span style="color: red;">
                                                {{serviceType=='Ground' ? 'Plate' : 'Tail'}} Number is required.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Category<span class="text-danger"><b>*</b></span></label>
                                    <select name="category" class="form-control" #category="ngModel" id="category"
                                        [(ngModel)]="vehicle.aircraftCategoryId"
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && category.invalid }" required>

                                        <option value="" disabled>Select Category</option>
                                        <option
                                            *ngFor="let item of serviceType=='Ground'?vehicleCategory:aircraftCategoryList"
                                            [value]="item.appCategoryId">
                                            {{item?.name}}
                                        </option>
                                    </select>
                                    <div *ngIf="loginForm.submitted && category.invalid" class="invalid-feedback">
                                        <div *ngIf="category.errors.required"><span style="color: red;">Category is
                                                required.</span></div>
                                    </div>

                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Year <span *ngIf="selectedVendorDetails?.isContracted" class="text-danger"><b>*</b></span></label>
                                    <input type="text"
                                           numbersOnly
                                           id="year"
                                           placeholder="Year"
                                           name="year"
                                           maxlength="4"
                                           #year="ngModel"
                                           class="form-control"
                                           [(ngModel)]="vehicle.year"
                                           [ngClass]="{ 'is-invalid': loginForm.submitted && year.invalid }"
                                           [required]="selectedVendorDetails?.isContracted"
                                    >
                                    <div *ngIf="selectedVendorDetails?.isContracted && loginForm.submitted && year.invalid" class="invalid-feedback">
                                        <div *ngIf="year.errors.required"><span class="text-danger"> Year is required.</span></div>
                                    </div>
                                </div>
                            </div>
                          <div class="col-md-6" *ngIf="isVinNumberFieldVisible">
                            <div class="form-group">
                              <label>VIN number</label>
                              <input type="text"
                                     id="year"
                                     placeholder="VIN number"
                                     name="vinNumber"
                                     maxlength="17"
                                     minlength="17"
                                     pattern="^[A-Za-z0-9]{17}$"
                                     #vinNumber="ngModel"
                                     class="form-control"
                                     [(ngModel)]="vehicle.vinNumber"
                                     [ngClass]="{ 'is-invalid': loginForm.submitted && vinNumber.invalid }"
                              >
                            </div>
                          </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Location <span *ngIf="selectedVendorDetails?.isContracted" class="text-danger"><b>*</b></span></label>
                                    <button type="button" id="addLocationPopUp" data-target="#addLocation"
                                        data-toggle="modal" class="plus-icon" title="Create Location"
                                        (click)="getStateList()" (click)="isCityButtonShow=false;isShowAddCity=false">
                                        <i class=" fa fa-plus-circle"></i>
                                    </button>
                                  <ngx-select-dropdown tabindex="0"
                                                       [multiple]="false"
                                                       name="location1"
                                                       #location1="ngModel"
                                                       id="originDropDown"
                                                       (change)="selectAddress($event)"
                                                       [(ngModel)]="addressName"
                                                       [config]="mapOriginConfig"
                                                       [options]="locationList"
                                                       [ngClass]="{'is-invalid': loginForm.submitted && location1.invalid }"
                                                       [required]="selectedVendorDetails?.isContracted"
                                  ></ngx-select-dropdown>
                                  <div *ngIf="selectedVendorDetails?.isContracted && loginForm.submitted && location1.invalid" class="invalid-feedback">
                                    <div *ngIf="location1.errors.required"><span class="text-danger">Location is required.</span></div>
                                  </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Upload Picture </label>
                                    <label class="d-flex">
                                        <input type="file" class="mt-2 cursorPointer" accept=".jpg,.jpeg,.png,.pdf"
                                            name="uploadProfilePicture" [(ngModel)]="uploadPicture"
                                            id="uploadProfilePicture" (input)="bindFileName(uploadPicture)"
                                            [style.width]="vehicleImag == true && headerName=='Edit'? '85px' : '100%'" />
                                        <span class=" imageName mt-2 ml-2" id="logoName"
                                            *ngIf="vehicleImag == true && headerName=='Edit'">{{vehicle?.filePath}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="serviceType=='Ground'">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Upload Insurance</label>
                                    <label class="d-flex">
                                        <input type="file" class="mt-2 cursorPointer" accept=".jpg,.jpeg,.png,.pdf"
                                            name="insuranceFile" id="insuranceFile" #insuranceFileInput
                                            (input)="setInsuranceFile('insuranceFile')"
                                            [style.width]="(selectedInsuranceFiles.length > 0 || insuranceFile!=undefined) && headerName=='Edit'? '85px':'100%'" />
                                        <span class="imageName mt-2 ml-2"
                                            *ngIf="(selectedInsuranceFiles.length>0 || insuranceFile!=undefined) && headerName=='Edit'">
                                            {{selectedInsuranceFiles[0]?.displayName}}
                                        </span>
                                        <span class="imageName mt-2 ml-2"
                                            *ngIf="selectedInsuranceFiles.length==0 && insuranceFile!=undefined && headerName=='Edit'">
                                            {{insuranceFile?.displayName}}
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Insurance Expiration Date <span *ngIf="selectedVendorDetails?.isContracted" class="text-danger"><b>*</b></span></label>
                                    <div class="datetimepicker endtimeDate">
                                        <div class="datetimepicker endtimeDate"
                                            (click)="initializeInsuranceExpirationDateDatepicker()">
                                          <input type="text"
                                                 id="insuranceExpirationDate"
                                                 name="insuranceExpirationDate"
                                                 #insuranceExpirationDate="ngModel"
                                                 class="form-control"
                                                 autocomplete="off"
                                                 placeholder="Insurance Expiration Date"
                                                 [ngModel]="insuranceExpirationTimeDatepicker"
                                                 [required]="selectedVendorDetails?.isContracted"
                                                 (ngModelChange)="insuranceExpirationTime=$event"
                                          />
                                            <i class=" fa fa-calendar calendar-icon"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>
                                        {{serviceType=='Ground'?'Upload Registration':'Upload Safety Credentials'}}
                                    </label>
                                    <label class="d-flex">
                                        <input type="file" class="mt-2 cursorPointer" accept=".jpg,.jpeg,.png,.pdf"
                                            name="registrationFile" id="registrationFile" #registrationFileInput
                                            (input)="setRegistrationFile('registrationFile')"
                                            [style.width]="(selectedRegistrationFiles.length > 0 || registrationFile!=undefined) && headerName=='Edit'? '85px':'100%'" />
                                        <span class="imageName mt-2 ml-2"
                                            *ngIf="(selectedRegistrationFiles.length>0 || registrationFile!=undefined) && headerName=='Edit'">
                                            {{selectedRegistrationFiles[0]?.displayName}}
                                        </span>
                                        <span class="imageName mt-2 ml-2"
                                            *ngIf="selectedRegistrationFiles.length==0 && registrationFile!=undefined && headerName=='Edit'">
                                            {{registrationFile?.displayName}}
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ registrationExpirationTitle }} <span *ngIf="selectedVendorDetails?.isContracted" class="text-danger"> <b>*</b></span></label>
                                    <div class="datetimepicker endtimeDate">
                                        <div class="datetimepicker endtimeDate" (click)="initializeRegistrationExpirationDatepicker()">
                                          <input type="text"
                                                 id="registrationExpirationDate"
                                                 name="registrationExpirationDate"
                                                 #registrationExpirationDate="ngModel"
                                                 class="form-control"
                                                 autocomplete="off"
                                                 [placeholder]="registrationExpirationTitle"
                                                 [ngModel]="registrationExpirationDatepicker"
                                                 [required]="selectedVendorDetails?.isContracted"
                                          />
                                          <i class=" fa fa-calendar calendar-icon"></i>
                                        </div>
                                    </div>
                                  <div *ngIf="registrationExpirationDate.touched && registrationExpirationDate.hasError('required')" class="text-danger">
                                    {{ registrationExpirationTitle }} is required.
                                  </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <label>Description</label>
                                    <textarea id="des" placeholder="Description" class="form-control h-w "
                                        name="description" [(ngModel)]="vehicle.description" maxlength="256"
                                        (ngModelChange)="descriptionSize($event)"></textarea>
                                    <div *ngIf="display==true"><span style="color: red;">Description must not exceed 255
                                            characters.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                            data-dismiss="modal"
                            (click)="resetForm(loginForm);clearVehicleData();emitPopupCloseEvent()">Cancel</button>
                        <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                                *ngIf="headerName=='Add'"
                                (click)="addVehicleDetails(serviceType, loginForm)"
                        >
                          Save Changes
                        </button>
                        <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                                *ngIf="headerName=='Edit'"
                                (click)="editVehicleDetails(serviceType, loginForm)"
                        >
                          Save Changes
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal fade" data-backdrop="static" data-keyboard="false" id="addLocation" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close"
                    (click)="closeLocation('addLocation'); resetLocationForm(addLocationForm)">
                    <i class="fa fa-close"></i>
                </button>
                <h4 class="modal-title">Create Location</h4>
            </div>
            <form name="addLocationForm" #addLocationForm="ngForm">
                <div class="modal-body">
                    <div class="member-card">
                        <h4 class="filter-options">Address Details</h4>
                        <hr class="hr-class" />

                        <div class="col-md-12">
                            <div class="row">
                                <input type="text" #pick id="autocompleteAddress" class="form-control autocomplete-addr"
                                    [(ngModel)]="searchedAddr" name="searchAddr" (ngModelChange)="autoSearchAddress()"
                                    placeholder="Search">
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-12">
                                <label>Location Name</label><span class="text-danger"> * </span>
                                <input type="text" name="addressName" id="addressName"
                                    [(ngModel)]="Location.addressName" placeholder="Location Name" class="form-control"
                                    maxlength="255" required />
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>Address Type</label><span class="text-danger"> * </span>
                                <select name="addressType" #addressType="ngModel" class="form-control"
                                    [(ngModel)]="Location.LocationAddressType"
                                    [ngClass]="{ 'is-invalid': addLocationForm.submitted && addressType.invalid }"
                                    required>
                                    <option [value]="null" selected disabled>Select Address Type</option>
                                    <option *ngFor="let item of AddressType" [value]="item" name="addr_type">
                                        {{item}}
                                    </option>
                                </select>
                                <div *ngIf="addLocationForm.submitted && addressType.invalid" class="invalid-feedback">
                                    <div *ngIf="addressType.errors.required"><span style="color: red;">Address Type is
                                            required.</span></div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Address</label><span class="text-danger"> * </span>
                                    <div class="radio my-0">
                                        <label>
                                            <input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                                                [(ngModel)]="Location.isGlobal" [value]="false" />Private
                                        </label>
                                        <label class="ml-4">
                                            <input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                                                [(ngModel)]="Location.isGlobal" [value]="true" />Public
                                        </label>
                                        <label class="ml-4">
                                            <input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                                                [(ngModel)]="Location.isGlobal" [value]="null" />Airport
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row form-group" *ngIf="Location.isGlobal == null">
                            <div class="col-md-6">
                                <label>Airport Code </label><span class="text-danger"> * </span>
                                <button type="button" id="addAirportCode" (click)="isShowAddAirportCode = true"
                                    class="plus-icon" *ngIf="!isShowAddAirportCode" title="Add Airport Code">
                                    <i class="fa fa-plus-circle "></i>
                                </button>
                                <button type="button" class="plus-icon" title="Cancel Add Airport Code"
                                    *ngIf="isShowAddAirportCode" (click)="isShowAddAirportCode = false; airport=''">
                                    <i class="fa fa-times-circle"></i>
                                </button>
                                <div *ngIf="isShowAddAirportCode">
                                    <div class="col-md-8 px-0">
                                        <input type="text" class="form-control" placeholder="Enter Airport Code"
                                            name="airportCodeName" #airportCodeName="ngModel" [(ngModel)]="airport"
                                            [value]="airport | uppercase" maxlength="4" required>
                                    </div>
                                    <div class="col-md-4 pr-0">
                                        <button
                                            class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                            type="submit" (click)="isShowAddAirportCode = false; addAirportCode()">
                                            Save
                                        </button>
                                    </div>
                                </div>
                                <select *ngIf="!isShowAddAirportCode" name="airportCode" #airportCode="ngModel"
                                    class="form-control" [(ngModel)]="Location.airportCode"
                                    [ngClass]="{ 'is-invalid': addLocationForm.submitted && airportCode.invalid }"
                                    required>
                                    <option [value]="null" selected disabled>Select Airport Code</option>
                                    <option *ngFor="let item of airportCodeList" [value]="item.airportCode"
                                        name="state">
                                        {{item?.airportCode}}
                                    </option>
                                </select>
                                <!--todo commented as no details for airportCode-->
                                <!--<div *ngIf="addLocationForm.submitted && airportCode && airportCode.invalid"
                                    class="text-danger">
                                    <div *ngIf="airportCode.errors.required">
                                        <span class="text-danger">
                                            Airport Code is required.
                                        </span>
                                    </div>
                                </div>-->
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>Street Address</label><span class="text-danger"> * </span>
                                <input type="text" name="streetAddress" id="CMStreetAddress"
                                    placeholder="Street Address" class="form-control"
                                    [(ngModel)]="Location.streetAddress" />
                            </div>
                            <div class="col-md-6">
                                <label>Zipcode</label><span class="text-danger"> * </span>
                                <input type="text" id="CMZipcode" placeholder="Zipcode" name="Zipcode"
                                    class="form-control" maxlength="5" minlength="3" pattern="[A-Za-z0-9]+"
                                    [(ngModel)]="Location.zipcode" #zipCode="ngModel" />
                                <div *ngIf="addLocationForm.submitted && zipCode.invalid" class="invalid-feedback">
                                    <div *ngIf="zipCode.errors.pattern">
                                        <span style="color: red;">ZipCode not valid.</span>
                                    </div>
                                    <div *ngIf="zipCode.errors.minlength">
                                        <span style="color: red;">ZipCode must have 3 or 5 digits.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>State</label><span class="text-danger"> * </span>
                                <select name="state" class="form-control" [(ngModel)]="Location.stateId"
                                    (change)="getCityByState(Location.stateId)" #stateName="ngModel">
                                    <option value="" selected disabled>Select State</option>
                                    <option *ngFor="let item of stateListForMember" [value]="item.stateId">
                                        {{item?.stateName}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label>City</label><span class="text-danger"> * </span>
                                <button type="button" id="addLocationPopUp" (click)="isShowAddCity=true"
                                    class="plus-icon" *ngIf="isCityButtonShow && !isShowAddCity" title="Add City">
                                    <i class=" fa fa-plus-circle "></i>
                                </button>
                                <button type=" button" class="plus-icon" title="Cancle Add City" *ngIf="isShowAddCity"
                                    (click)="isShowAddCity=!isShowAddCity;">
                                    <i class="fa fa-times-circle"></i>
                                </button>
                                <div *ngIf="isShowAddCity">
                                    <div class="col-md-8 px-0"><input type="text" class="form-control"
                                            placeholder="Enter City Name" name="city" [(ngModel)]="city.cityName">
                                    </div>
                                    <div class="col-md-4 pr-0">
                                        <button
                                            class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                            type="submit" (click)="addCity()"> Save </button>
                                    </div>
                                </div>
                                <select name="state" class="form-control" *ngIf="!isShowAddCity"
                                    [(ngModel)]="Location.cityId">
                                    <option value="" selected disabled>Select City</option>
                                    <option *ngFor="let item of cityList" [value]="item.cityId" name="city">
                                        {{item?.cityName}}</option>
                                </select>
                            </div>

                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                        (click)="closeLocation('addLocation'); clearLocation(); resetLocationForm(addLocationForm);">Cancel</button>
                    <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                        (click)="addLocation(Location, addLocationForm)">
                        Save Changes
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
